'use strict';

import request from 'superagent';
import api from './core';

export function emptyProducer() {
    return {
        id: undefined,
        name: '',
        zip_code: '',
        bureau_distributeur: '',
        phone_land: '',
        phone_cell: '',
        siret: '',
        date_enter: null,
        date_exit: null
    };
}

export function fetchPage(page = 1) {
    return api.prepare(request.get(api.url('/producers/'))).query({page});
}

export async function listAll() {
    let next = 1;
    const out = [];

    while (next) {
        const page = (await fetchPage(next)).body;

        if (page.next) {
            next += 1;
        } else {
            next = false;
        }

        out.push(...page.results);
    }

    return out;
}

export function create(producer) {
    return api.forwardResult(
        api.prepare(request.post(api.url('/producers/'))).send(producer),
        'id'
    );
}

export function update(producer) {
    const id = encodeURIComponent(producer.id);
    return api.forwardResult(
        api.prepare(request.put(api.url(`/producers/${id}/`))).send(producer),
        'id'
    );
}



// WEBPACK FOOTER //
// ./src/api/producers.js